
import lodash from "lodash";
import { Component, Vue, Watch } from "vue-property-decorator";
import router from "@/router";
import wb from "./registerServiceWorker";
import VueCookies from "vue-cookies";
import { downloadApkPackage } from "./helpers/download";
import { AppMode } from "@/store/modules/scan";
import AppSettings from "./app-settings";
import * as logRocket from "@/helpers/log-rocket";

Vue.use(VueCookies);

declare var navigator: any;
@Component({
  components: {},
})
export default class App extends Vue {
  created() {
    if (wb)
      wb.addEventListener("waiting", async () => {
        //Update is ready, waiting
        this.$store.commit("popup/displayYesNo", {
          message: "An update is available. Would you like to update?",
          yesAction: async () => {
            if (wb) {
              await wb.messageSW({ type: "SKIP_WAITING" });
              window.location.reload();
            } else throw Error("No wb to messageSW SKIP_WAITING");
          },
        });
      });
    //console.log("App created")
    this.$store.dispatch("onAppCreated");
    this.$store.commit("snackbarHide");
  }

  popupKeyDown(event: any) {
    if (event.keyCode === 13) {
      this.$store.commit("popup/hide");
    }
  }

  downloadApkPackage() {
    downloadApkPackage("app-debug");
  }

  buttonState(appMode: AppMode) {
    return this.$store.getters["scan/isAppModeAllowedToContinue"](appMode);
  }

  onFooterClick() {
    //TODO: Refresh hardware server status check
  }

  navigationDrawer: boolean = false;

  isBusyUploading: boolean = false;

  get statusMessage() {
    return this.$store.getters["scan/getScanStatusMessage"];
  }

  beforeMount() {
    const isElectron = navigator.userAgent.includes("Electron");
    if (isElectron) return;

    const preventNav = (event: BeforeUnloadEvent) => {
      event.preventDefault();
      event.returnValue = "";
    };
    window.addEventListener("beforeunload", preventNav);
    this.$once("hook:beforeDestroy", () => window.removeEventListener("beforeunload", preventNav));
  }

  mounted() {
    //console.log("App mounted");

    //this.$store.dispatch("onAppCreated");

    this.$vuetify.theme.dark = this.$store.state.settings.appSettings.isDarkMode;

    if (!navigator.connection.onchange) {
      navigator.connection.onchange = (e: any) => {
        //console.log("navigator.connection.onchange begin");
        if (!this.isBusyUploading) {
          this.isBusyUploading = true;
          /*
          It seems that a network change to no network also counts, so here we'll just wait a while to give the device chance
          to connect to another connection.
          */

          lodash.debounce(async () => {
            console.log("network onchange upload");
            await this.$store.dispatch("upload/upload");
            this.isBusyUploading = false;
          }, 5000)();
        }
        //console.log("navigator.connection.onchange end");
      };

      //Just to clear out a bug we had where the outbox number would go negative
      if (this.$store.state.upload.numYetToUpload < 0) this.$store.commit("upload/numYetToUpload", 0);
    }

    logRocket.initialize(this.$store);
  }

  toggleLightDarkMode() {
    const appSettings: AppSettings = this.$store.state.settings.appSettings;
    appSettings.isDarkMode = appSettings.isDarkMode ? false : true;
    this.$store.commit("settings/setAppSettings", appSettings);
    this.$vuetify.theme.dark = this.$store.state.settings.appSettings.isDarkMode;
  }

  bulletClass(bullet: string) {
    if (bullet.startsWith("Warning:")) return "dialog-bullet dialog-bullet--warning";
    if (bullet.startsWith("Tip:")) return "dialog-bullet dialog-bullet--tip";
    return "dialog-bullet";
  }
}
